module.exports = function(app) {

    app.controller('pages.forgotPassword.accountRecovery.step4.verify', ["$state", "$scope", "userService", "verifyCode",
        function($state, $scope, userService, verifyCode) {

            var newPassword = "";
            var verifyPassword = "";
            var user = "";
            var userTokenParam = $state.params.userToken || "";
            var verificationCodeParam = $state.params.verificationCode || "";


            var invalidRequest = function(params) {
                $scope.$parent.goto(1, false, params);
            };

            // If step4 is called directly, get the user token and verification code from the state parameters.
            if (userTokenParam && verificationCodeParam && userTokenParam.length > 0 && verificationCodeParam.length > 0) {
                user = { userToken: userTokenParam, verificationCode: verificationCodeParam};
            }
            // If step4 is called without the user token or the verification code, re-direct to step1.
            if (user === "" ||  !(user && user.userToken && user.userToken.length > 0) ||  !(user && user.verificationCode && user.verificationCode.length > 0)) {
                invalidRequest();
            }

            // Verify Code Match service is called in the state's resolve.
            if (verifyCode) {
                var baseMessage = userService.parseBaseMessage(verifyCode);

                if (baseMessage && baseMessage.returnCode === 200) {
                    $scope.$parent.updateChevron(4,  true);
                    $scope.$parent.goto(4, true, {user: user });

                } else if (baseMessage && baseMessage.returnCode === 404) {
                    var context = (baseMessage.businessContext && baseMessage.businessContext.length > 0) ? baseMessage.businessContext : 'UNKNOWN_404';
                    invalidRequest({ error: { code: baseMessage.returnCode, context: context } }); // UserToken is not valid, lets go back to step1...

                } else {
                    invalidRequest();
                }
            } else {
                invalidRequest(); // If verify code service wasn't executed, lets go back to step1...
            }

        }
    ]);
};